const system_manager_routes = {
      path: "/system",
      name: "System",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "sm",
          component: () => import("@/views/system_manager/Home"),
          meta: {requiresAuth: true}
        },
        /* 机构列表 */
        {
          path: "org",
          component: () => import("@/views/system_manager/organization/org-organization"),
          meta: {requiresAuth: true}
        },
        /* 机构管理 - 机构详情 */
        {
          path: "od",
          component: () => import("@/views/system_manager/organization/org-detail"),
          meta: {requiresAuth: true}
        },
        /* 机构管理 - 培训班详情(不再跳此路由) */
        /*{
          path: "oc",
          component: () => import("@/views/system_manager/organization/org-course"),
          meta: {requiresAuth: true}
        },*/
        /* 机构管理 - 精彩瞬间 */
        {
          path: "won",
          component: () => import("@/views/system_manager/Wonderful"),
          meta: {requiresAuth: true}
        },
        /* 培训班管理 */
        {
          path: "class",
          component: () => import("@/views/system_manager/class/class-manage"),
          meta: {requiresAuth: true}
        },
        {
          path: "train_sign_up",
          component: () => import("@/views/system_manager/class/sign_up/train-sign-up"),
          meta: {requiresAuth: true}
        },
        {
          path: "train_high_class",
          component: () => import("@/views/system_manager/class/class-high"),
          meta: {requiresAuth: true}
        },
        {
          path: "create_sign_up/:classLevel/:enrollType",
          props:true,
          component: () => import("@/views/system_manager/class/sign_up/create-sign-up"),
          meta: {requiresAuth: true}
        },
        {
          path: "create_high_class",
          props:true,
          component: () => import("@/views/system_manager/class/sign_up/create-high-class"),
          meta: {requiresAuth: true}
        },
        {
          path: "create_high_class_second",
          props:true,
          component: () => import("@/views/system_manager/class/sign_up/create-high-class-second"),
          meta: {requiresAuth: true}
        },
        {
          path: "create_high_class_second_education",
          props:true,
          component: () => import("@/views/system_manager/class/sign_up/create-high-class-second-education"),
          meta: {requiresAuth: true}
        },
        {
          path: "edit_sign_up/:signId",
          props:true,
          component: () => import("@/views/system_manager/class/sign_up/edit-sign-up"),
          meta: {requiresAuth: true}
        },
        {
          path: "sign_up_detail",
          component: () => import("@/views/system_manager/class/sign_up/sign-up-detail"),
          meta: {requiresAuth: true}
        },
        {
          path: "class_detail",
          component: () => import("@/views/system_manager/class/class-detail"),
          meta: {requiresAuth: true}
        },
        /* 成绩管理 */
        {
          path: "class_score_list",
          component: () => import("@/views/system_manager/score/score-manage"),
          meta: {requiresAuth: true}
        },
        {
          path: "history_score",
          component: () => import("@/views/system_manager/score/history-score"),
          meta: {requiresAuth: true}
        },
        {
          path: "coach_score",
          component: () => import("@/views/system_manager/score/coach-score"),
          meta: {requiresAuth: true}
        },
        /* 讲师列表 */
        {
          path: "tea",
          component: () => import("@/views/system_manager/teacher/tea-teacher"),
          meta: {requiresAuth: true}
        },
        /* 讲师列表 已删除的*/
        {
          path: "tea_removes",
          component: () => import("@/views/system_manager/teacher/tea-teacher-removes"),
          meta: {requiresAuth: true}
        },
        /* 助理讲师晋升统计列表 */
        {
          path: "tea_promote",
          component: () => import("@/views/system_manager/teacher/tea-teacher-promote"),
          meta: {requiresAuth: true}
        },
        /* 讲师培训历程 */
        {
          path: "td",
          component: () => import("@/views/system_manager/teacher/tea-train"),
          meta: {requiresAuth: true}
        },
        /* 讲师培训班详情(不再跳此路由) */
        /*{
          path: "tc",
          component: () => import("@/views/system_manager/teacher/tea-course"),
          meta: {requiresAuth: true}
        },*/
        /* 学员管理 */
        {
          path: "stu",
          component: () => import("@/views/system_manager/student/stu-student"),
          meta: {requiresAuth: true}
        },
        /* 学员培训历程 */
        {
          path: "st",
          component: () => import("@/views/system_manager/student/stu-train"),
          meta: {requiresAuth: true}
        },
          /* 资质审核*/
        {
            path:"review",
            component: () => import("@/views/system_manager/review/review"),
            meta: {requiresAuth: true},
        },
          /* 资格审核 */
        {
          path:"qualification",
          component :() => import('@/views/system_manager/review/qualification'),
          meta: {requiresAuth: true},
        },
        /* 信息确认 */
        {
          path:"confirmInfo",
          component :() => import('@/views/system_manager/review/confirmInfo'),
          meta: {requiresAuth: true},
        },
        /* 资格审核的一条记录 */
        {
          path:"record",
          component :() => import('@/views/system_manager/review/record'),
          meta: {requiresAuth: true},
        },

        /* 失信名单列表 */
        {
          path:"blacklist",
          component :() => import('@/views/system_manager/BlackList/BlackList'),
          meta: {requiresAuth: true},
        },
        /* 失信人员申诉列表 */
        {
          path:"peopleAppealList",
          component :() => import('@/views/system_manager/BlackList/peopleAppealList'),
          meta: {requiresAuth: true},
        },
        /* 失信人员申诉详情 */
        {
          path:"peopleAppealInfo",
          component :() => import('@/views/system_manager/BlackList/appealInfo'),
          meta: {requiresAuth: true},
        },
        /* 文件存档 */
        {
          path:'documents',
          component: () => import('@/views/Documents/Documents'),
          meta: {requiresAuth: true}
        },

        /* 学习资料列表 */
        {
          path:'materials',
          component: () => import('@/views/Materials/Documents'),
          meta: {requiresAuth: true}
        },

        /* 带生成执照列表 */
        {
          path:"licenseWait",
          component :() => import('@/views/system_manager/LicenseWait/LicenseWait'),
          meta: {requiresAuth: true},
        },
        /* 已生成执照列表 */
        {
          path:"licenseList",
          component :() => import('@/views/system_manager/LicenseWait/licenseList'),
          meta: {requiresAuth: true},
        },

        /* 考评管理 */
        {
          path: "eva",
          redirect: "eva/class",
          component: () => import("@/views/system_manager/evaluation/eva-evaluation"),
          meta: {requiresAuth: true},
          children: [
            {
              path: 'class',
              component: () => import("@/views/system_manager/evaluation/eva-class"),
              meta: {requiresAuth: true},
            },
            {
              path: 'tea',
              component: () => import("@/views/system_manager/evaluation/eva-teacher"),
              meta: {requiresAuth: true},
            },
            {
              path: 'org',
              component: () => import("@/views/system_manager/evaluation/eva-organization"),
              meta: {requiresAuth: true},
            },
            {
              path: 'tpl',
              component: () => import("@/views/system_manager/evaluation/eva-template"),
              meta: {requiresAuth: true},
            },
          ]
        },
        {
          path: "eva_tpl_setting",
          component: () => import("@/views/system_manager/evaluation/eva-setting"),
          meta: {requiresAuth: true}
        },
        {
          path: "eva_class_detail",
          component: () => import("@/views/system_manager/evaluation/eva_detail/eva-class-detail"),
          meta: {requiresAuth: true},
        },
        {
          path: "eva_tea_detail",
          component: () => import("@/views/system_manager/evaluation/eva_detail/eva-teacher-detail"),
          meta: {requiresAuth: true},
        },
        {
          path: "eva_org_detail",
          component: () => import("@/views/system_manager/evaluation/eva_detail/eva-organization-detail"),
          meta: {requiresAuth: true},
        },

        /* 新增需求 */
        /* 学员信息 */
        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        /* 教案详情 */
        {
          path: "tutorial_detail",
          component: () => import('@/components/Tutorial/tutorial-detail'),
          meta: {requiresAuth: true},
        },
        /* 单个学员教案 */
        {
          path: "stu_tutorial",
          component: () => import('@/views/training_teacher/student-tutorial'),
          meta: {requiresAuth: true},
        },
        // 修改编辑培训班
        {
          path: 'edit_class/:classId',
          name: 'SystemEditTrainClass',
          component: () => import('@/views/TraingingManager/EditClass/EditClass'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 修改编辑培训班 - 五人制
        {
          path: 'edit_class_five/:classId',
          name: 'SystemEditTrainClassFive',
          component: () => import('@/views/TraingingManager/EditClass/EditClassFive'),
          props: true,
          meta: {requiresAuth: true},
        },
        /* 教案管理 */
        {
          path: "tutorial_res",
          component: () => import('@/views/system_manager/tutorial/tutorial-official'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_other",
          component: () => import('@/views/system_manager/tutorial/tutorial-person'),
          meta: {requiresAuth: true},
        },
        /* 查看成绩 */
        {
          path: "look_score",
          component: () => import('@/components/score/score-detail'),
          meta: {requiresAuth: true},
        },
        /* 编辑成绩 */
        {
          path: "edit_score",
          component: () => import('@/components/score/upload-score'),
          meta: {requiresAuth: true},
        },
        { // 五人制上传成绩报告单
          path: "upload_score_report_five",
          component: () => import('@/components/score/five-upload-score-report'),
          meta: {requiresAuth: true},
        },
        {
          path: "edit_score_education",
          component: () => import('@/components/score/upload-score-education'),
          meta: {requiresAuth: true},
        },
        {
          path: "class_report",
          component: () => import('@/components/score/class-report'),
          meta: {requiresAuth: true},
        },
        {
          path: "tran_his",
          name: 'sysTrainingHis',
          component: () => import('@/views/TraingingManager/TrainingHis/TrainingHis'),
          meta: {requiresAuth: true},
        },
        { // 高端培训班招标计划列表
          path: "heigh_class_plane",
          name: 'SysHeighClassPlaneList',
          component: () => import('@/views/system_manager/heighClassPlane/HeightClassPlaneList'),
          meta: {requiresAuth: true},
        },
        { // 高端培训班招标计划创建
          path: "create_edit_heigh_class_plane",
          name: 'SysHeighClassPlaneCreate',
          component: () => import('@/views/system_manager/heighClassPlane/CreateHeighClassPlane'),
          meta: {requiresAuth: true},
        },
        { // 高端培训班招标计划查看
          path: "view_heigh_class_plane",
          name: 'SysHeighClassPlaneView',
          component: () => import('@/views/system_manager/heighClassPlane/ViewHeighClassPlane'),
          meta: {requiresAuth: true},
        },
        { // 教练员注册申请通知列表
          path: "org_alter_list",
          name: 'OrgAlterList',
          component: () => import('@/views/system_manager/orgAlteration/AlterList'),
          meta: {requiresAuth: true},
        },
        { // 教练员注册申请复核列表
          path: "reconsider_list",
          name: 'ReconsiderList',
          component: () => import('@/views/system_manager/orgAlteration/ReconsiderList'),
          meta: {requiresAuth: true},
        },
        { // 教练员注册申请复核详情
          path: "reconsider_info",
          name: 'ReconsiderInfo',
          component: () => import('@/views/system_manager/orgAlteration/components/ReconsiderSeeDetails'),
          meta: {requiresAuth: true},
        },
        { // 教练员注册申请通知创建/编辑
          path: "org_alter_action",
          name: 'OrgAlterAction',
          component: () => import('@/views/system_manager/orgAlteration/AlterationApply'),
          meta: {requiresAuth: true},
        },
        { // 教练员注册申请通知创建/编辑
          path: "org_alter_view",
          name: 'OrgAlterView',
          component: () => import('@/views/system_manager/orgAlteration/AlterationApplyDetails1'),
          meta: {requiresAuth: true},
        },
        // 培训班开班申请管理
        {
          path:'class_application',
          name: 'ClassApplication',
          component: () => import('@/views/TraingingManager/TheClassApplication/ClassApplicationManager'),
          meta: {requiresAuth: true}
        },
        // 查看五人制培训班开班申请
        {
          path:'class_application_info',
          name: 'ClassApplicationInfo',
          component: () => import('@/components/ClassApplication/class-application-detail'),
          meta: {requiresAuth: true}
        },
        // 创建/编辑五人制培训班开班申请
        {
          path:'class_application_five_action',
          name: 'ClassApplicationFiveAction',
          component: () => import('@/views/TraingingManager/TheClassApplication/ClassApplicationAction'),
          meta: {requiresAuth: true}
        },
        
        // 继续教育列表
        {
          path:'education_train_list',
          name: 'EducationTrainList',
          component: () => import('@/views/system_manager/education/EducationList'),
          meta: {requiresAuth: true}
        },
        // 添加/编辑继续教育第一步
        {
          path:'education_crate_one',
          name: 'EducationCrateOne',
          component: () => import('@/views/system_manager/education/EducationCreateOne'),
          meta: {requiresAuth: true}
        },
        // 添加/编辑继续教育第二步
        {
          path:'education_crate_second',
          name: 'EducationCrateSecond',
          component: () => import('@/views/system_manager/education/Create-education-second'),
          meta: {requiresAuth: true}
        },
        // 继续教育详情
        {
          path: "education_detail",
          component: () => import("@/views/system_manager/education/Education-detail"),
          meta: {requiresAuth: true}
        },
        // 查看某个学员的学习详情
        {
          path: "student_study_learn_view",
          component: () => import("@/views/system_manager/education/studentStudyLearnView"),
          meta: {requiresAuth: true}
        },
        // 调整学员名单🎈
        {
          path: 'edit_stus_info/:classId',
          name: 'EditStusInfoSystem',
          component: () => import('@/views/TraingingManager/EditStusInfo/EditStusInfo'),
          props: true,
          meta: {requiresAuth: true},
        },
        { // 开班计划列表
          path: "sys_class_plan",
          name: 'SysClassPlanList',
          component: () => import('@/views/system_manager/classPlan/ClassPlanList'),
          meta: {requiresAuth: true},
        },
        /* 开班计划详情 */
        {
          path: "class_plan_detail",
          name: 'SysClassPlanDetail',
          component: () => import("@/views/system_manager/classPlan/class-plan-detail"),
          meta: {requiresAuth: true}
        },
        /* 意见反馈 */
        {
          path:'feedback',
          name: 'Feedback',
          component: () => import('@/views/system_manager/feedback/feedback'),
          meta: {requiresAuth: true}
        },
        /* 投诉详情 */
        {
          path:'feedbackInfo',
          name: 'FeedbackInfo',
          component: () => import('@/views/system_manager/feedback/components/feedbackInfo'),
          meta: {requiresAuth: true}
        },
        /* 培训班中学员信息确认 */
        {
          path:"confirmInfoClass",
          component :() => import('@/views/system_manager/review/confirmInfoClass'),
          meta: {requiresAuth: true},
        },
        /* 处罚申请列表 */
        {
          path:"punishPeopleAudit",
          component :() => import('@/views/system_manager/BlackList/punishPeopleAudit'),
          meta: {requiresAuth: true},
        },
        /* 处罚申请详情 */
        {
          path:"punishApply",
          component :() => import('@/views/punishPeople/punishApplyInfo'),
          meta: {requiresAuth: true},
        },
        /* 处罚详情 */
        {
          path:"punishResultInfo",
          component :() => import('@/views/punishPeople/punishResultInfo'),
          meta: {requiresAuth: true},
        },
        /* 高水平职业球员认证列表 */
        {
          path:"authenticationList",
          component :() => import('@/components/highPlayerAuthentication/AuthenticationList'),
          meta: {requiresAuth: true},
        },
        /* 高水平球员认证详情 */
        {
          path:'authenticationInfo',
          name: 'AuthenticationInfo',
          component: () => import('@/components/highPlayerAuthentication/AuthenticationInfo'),
          meta: {requiresAuth: true}
        },
        // 创建培训班 五人制 高端班
        {
          path: 'create_class_five/:status/:level',
          name: 'CreateTrainingClassFiveHigh',
          component: () => import('@/views/TraingingManager/CreateClass/CreateClassFiveHigh'),
          meta: {requiresAuth: true},
        },
        // 修改编辑培训班 - 五人制 高端班
        {
          path: 'edit_class_five_high/:classId',
          name: 'SystemEditTrainClassFiveHigh',
          component: () => import('@/views/TraingingManager/EditClass/EditClassFiveHigh'),
          props: true,
          meta: {requiresAuth: true},
        },
        {
          path:"classFeedOtherAdd",
          name:'ClassFeedOtherAdd',
          component:()=> import("@/components/ClassComplaint/ClassFeedOtherAdd"),
          meta: {requiresAuth: true}
        },
        {
          path: "bigDataHome",
          component: () => import("@/views/system_manager/BigDataHome"),
          meta: {requiresAuth: true}
        },
        {
          path: "coachExport",
          component: () => import("@/views/coachExport/CoachExport"),
          meta: {requiresAuth: true}
        },
      ]
}

export default system_manager_routes;
